import { render, staticRenderFns } from "./IconVisitor.vue?vue&type=template&id=67828598&"
import script from "./IconVisitor.vue?vue&type=script&lang=js&"
export * from "./IconVisitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67828598')) {
      api.createRecord('67828598', component.options)
    } else {
      api.reload('67828598', component.options)
    }
    module.hot.accept("./IconVisitor.vue?vue&type=template&id=67828598&", function () {
      api.rerender('67828598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconVisitor.vue"
export default component.exports